export const meta = {
  id: 'A02',
  slug: 'entenda-seu-diagnostico',
  title: 'Entenda seu Diagnóstico',
  description: 'Use o Diagnóstico como ponto de partida para identificar competências prioritárias.',
  profile: 'student',
  category: 'diagnostico',
  type: 'flow',
  status: 'published',
  order: 60,
  keywords: ['diagnóstico', 'competências', '5 competências', 'níveis', 'descritores', 'avaliação'],
  previous: 'A01',
  next: 'A02.1',
  related: ['A03', 'A04'],
  updatedAt: '2026-08-17',
  appVersion: 'v1'
}

# Entenda seu Diagnóstico

O Diagnóstico identifica seu ponto de partida. Ele não é um rótulo nem uma conclusão definitiva sobre você: serve para orientar prioridades de desenvolvimento.

## Como funciona

<Steps>
  <Step title="Inicie o Diagnóstico">
    Acesse o fluxo quando ele estiver disponível para você.
  </Step>
  <Step title="Escolha as competências">
    No fluxo atual, você seleciona **5 competências** para avaliar e desenvolver.
  </Step>
  <Step title="Avalie sua realidade atual">
    Use os níveis e descritores comportamentais como referência para responder de acordo com sua situação presente.
  </Step>
  <Step title="Conclua a avaliação">
    O resultado passa a alimentar seu Desenvolvimento, Plano e acompanhamento.
  </Step>
</Steps>

<HelpImage alt="Seleção de competências no Diagnóstico" pendingId="A02.2" />
<HelpImage alt="Avaliação por níveis e descritores no Diagnóstico" pendingId="A02.3" />

<Callout type="tip">
  Escolha competências relevantes para o que você precisa desenvolver agora, e não apenas aquelas em que já se sente forte.
</Callout>

<Callout type="important">
  Responda considerando sua realidade atual. O Diagnóstico é uma referência para desenvolvimento, não uma identidade permanente.
</Callout>
